<!-- src/app/meter/components/meter-analytics/meter-heatmap/meter-heatmap.component.html -->

<div class="heatmap-card">
    <div class="heatmap-header">
        <h3 class="chart-title">{{ 'meter.analytics.chart_heatmap' | translate }}</h3>
    </div>
    <div class="heatmap-container">
        <div id="meter-analytics-heatmap" class="map"></div>
        <div *ngIf="points.length === 0" class="no-data-overlay">
            {{ 'meter.analytics.no_data' | translate }}
        </div>
    </div>
    <div class="heatmap-footer">
        <span class="point-count">{{ points.length }} {{ 'meter.analytics.heatmap_points' | translate }}</span>
    </div>
</div>
